import React from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import type { Store } from '../Store/store';
import ShoppingCartPage from './ShoppingCartPage/ShoppingCartPage';
import WithLocaleProvider from './Provider/WithLocaleProvider';
import WithTranslationProvider from './Provider/WithTranslationProvider';
import type { WebshopContextData } from '../../general/WebshopContext/WebshopContextProvider';
import WebshopContextProvider from '../../general/WebshopContext/WebshopContextProvider';
import TopLayerProvider from '../../general/TopLayer/TopLayerContext';

export interface AppProps {
  contextData: WebshopContextData;
  store: Store;
}

const App: React.FC<AppProps> = ({ contextData, store }) => (
  <React.StrictMode>
    <ReduxProvider store={store}>
      <WithLocaleProvider>
        <WithTranslationProvider>
          <WebshopContextProvider data={contextData}>
            <TopLayerProvider>
              <ShoppingCartPage />
            </TopLayerProvider>
          </WebshopContextProvider>
        </WithTranslationProvider>
      </WithLocaleProvider>
    </ReduxProvider>
  </React.StrictMode>
);

export default App;
